import { mapUserFromDTO, User, UserApiResponse } from "./user"

export type ClientInput = {
    first_name?: string
    last_name?: string
    email?: string
    phone?: string
}
export type ClientApiPostRequest = {
    cognitoId: string
    tenant: {
        id: string
    }
    user: {
        firstName: string
        lastName: string
        email: string
        phone: string
        timezone: string
    }
}
export type ClientApiOutput = {
    id: string
    cognitoId: string
    tenant: {
        id: string
        name: string
        bizLogoUrl: string
        chargebeeCustomerId: string
    }
    user: {
        id: string
        firstName: string
        lastName: string
        email: string
        imageUrl?: string
        phone: string
        timezone: string
    }
}

export enum ClientMembershipStatus {
    CURRENT = 'CURRENT',
    LAPSED = 'LAPSED',
    NONE = 'NONE',
}

export type ClientDTO = {
    id?: string
    cognitoId?: string
    membershipStatus?: ClientMembershipStatus
    notes?: string
    pwaSubscriberId?: string
    user: UserApiResponse
    deletedAt?: string
}

export type Client = {
    id?: string
    cognito_id?: string
    membership_status?: ClientMembershipStatus
    notes?: string
    user: User
    is_archived?: boolean
}

export function mapClientFromDTO(client: ClientDTO): Client {
    return ({
        id: client.id,
        cognito_id: client.cognitoId,
        membership_status: client.membershipStatus,
        notes: client.notes,
        user: mapUserFromDTO(client.user),
        is_archived: !!client.deletedAt

    })
}

export const MAX_DATE = "3000-01-01"